module.exports = __webpack_public_path__ + "img/activity_qd.61537dad.png";